import { AbstractGlobalProvider } from './provider.js';
class Analytics extends AbstractGlobalProvider {
    name = 'uber-analytics-provider';
    trackGameplayStart() {
        for (const p of this.providers)
            p.trackGameplayStart();
    }
    trackGameplayStop() {
        for (const p of this.providers)
            p.trackLoadingStop();
    }
    trackLoadingStart() {
        for (const p of this.providers)
            p.trackLoadingStart();
    }
    trackLoadingStop() {
        for (const p of this.providers)
            p.trackLoadingStop();
    }
}
export const analytics = new Analytics();
